import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MapPin, Home, ArrowLeft } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>404 — Página não encontrada | Vem Pra Ilha do Mel</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="A página que você procura não foi encontrada." />
      </Helmet>

      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="max-w-xl w-full text-center">
          {/* Ícone */}
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-teal-50 flex items-center justify-center">
            <MapPin className="w-8 h-8 text-teal-deep" />
          </div>

          {/* 404 grande */}
          <h1 className="font-display text-8xl md:text-9xl text-teal-deep mb-2 tracking-wider">
            404
          </h1>

          {/* Título */}
          <h2 className="font-display text-2xl md:text-3xl text-warm-dark mb-4 tracking-wide">
            Página não encontrada
          </h2>

          {/* Descrição */}
          <p className="font-body text-warm-gray text-base md:text-lg mb-8 leading-relaxed max-w-md mx-auto">
            A página que você procura não existe ou foi movida.
            <br />
            Que tal explorar nosso guia completo da Ilha do Mel?
          </p>

          {/* Botões */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-coral hover:bg-coral-dark text-white font-body font-semibold rounded-xl px-6 py-3 transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-coral/20"
            >
              <Home className="w-4 h-4" />
              Página inicial
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-white border-2 border-teal-deep text-teal-deep hover:bg-teal-50 font-body font-semibold rounded-xl px-6 py-3 transition-all"
            >
              <ArrowLeft className="w-4 h-4" />
              Ilha do Mel
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
